// Geometry and available posts from E-Dropper Guideline.xlsx (MY26).
const edropperFrames = [
  ['All Mountain 7 Alloy', 'Full Suspension', 'S', 400, 227, 48],
  ['All Mountain 7 Alloy', 'Full Suspension', 'M', 440, 267, 48],
  ['All Mountain 7 Alloy', 'Full Suspension', 'L', 480, 307, 48],
  ['All Mountain 7 Carbon', 'Full Suspension', 'M', 440, 249, 48],
  ['All Mountain 7 Carbon', 'Full Suspension', 'L', 480, 289, 48],
  ['City 7', 'High Step', 'M', 500, 349, 60],
  ['City 7', 'High Step', 'L', 550, 399, 60],
  ['City 7', 'High Step', 'XL', 600, 449, 60],
  ['City 7', 'Low Step', 'S', 450, 299, 60],
  ['City 7', 'Low Step', 'M', 500, 349, 60],
  ['City 7', 'Low Step', 'L', 550, 399, 60],
  ['City 8', 'High Step', 'M', 450, 241, 55],
  ['City 8', 'High Step', 'L', 470, 259, 55],
  ['City 8', 'High Step', 'XL', 520, 309, 55],
  ['City 8', 'Low Step', 'M', 420, 309, 55],
  ['City 8', 'Low Step', 'L', 470, 359, 55],
  ['City 8', 'Low Step', 'XL', 520, 409, 55],
  ['Mountain 7', 'High Step', 'S', 400, 253, 48],
  ['Mountain 7', 'High Step', 'M', 450, 303, 48],
  ['Mountain 7', 'High Step', 'L', 500, 353, 48],
  ['Trekking 7', 'High Step', 'M', 490, 324, 60],
  ['Trekking 7', 'High Step', 'L', 520, 354, 60],
  ['Trekking 7', 'High Step', 'XL', 560, 409, 60],
  ['Trekking 7', 'Low Step', 'S', 460, 294, 60],
  ['Trekking 7', 'Low Step', 'M', 490, 329, 60],
  ['Trekking 7', 'Low Step', 'L', 520, 369, 60],
  ['Trekking 8', 'High Step', 'M', 450, 241, 55],
  ['Trekking 8', 'High Step', 'L', 470, 259, 55],
  ['Trekking 8', 'High Step', 'XL', 520, 309, 55],
  ['Trekking 8', 'Low Step', 'M', 420, 309, 55],
  ['Trekking 8', 'Low Step', 'L', 470, 359, 55],
  ['Trekking 8', 'Low Step', 'XL', 520, 409, 55],
  ['Urban 8', 'High Step', 'L', 470, 259, 55],
  ['Urban 8', 'High Step', 'XL', 520, 309, 55]
];

const edropperPosts = [
  { name: 'Rigid 300 mm', total: 300, insert: 260, minInsert: 80, travel: 0 },
  { name: '75 mm', total: 324.3, insert: 212.4, minInsert: 150, travel: 75 },
  { name: '125 mm', total: 424.3, insert: 262.4, minInsert: 150, travel: 125 },
  { name: '150 mm', total: 474.3, insert: 287.4, minInsert: 150, travel: 150 }
];

function calculateEdropper(frame, innerLegCm, position) {
  const targetHeight = innerLegCm * 10 * 1.041 - 161 - (position + 20) * 0.2;
  const neededHeight = targetHeight - frame[3] - frame[5];
  const fitting = edropperPosts.filter((post) => {
    const minExtended = post.total - post.insert;
    const maxExtended = post.total - post.minInsert;
    const insertion = post.total - neededHeight;
    return minExtended <= neededHeight &&
      maxExtended >= neededHeight &&
      insertion <= frame[4];
  });
  // Excel uses MAX(MINHeightExtended) among fitting, available posts.
  const post = fitting.reduce((best, item) =>
    !best || item.total - item.insert > best.total - best.insert ? item : best, null);
  if (!post) return null;

  const insertion = post.total - neededHeight;
  if (insertion > frame[4]) return null;
  const scale = Math.round((insertion - post.minInsert) / 5) / 2;
  return { post: post.name, scale };
}

class EdropperSizeCalculator extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.form = this.querySelector('form');
    this.model = this.form.elements.namedItem('model');
    this.frame = this.form.elements.namedItem('frame');
    this.size = this.form.elements.namedItem('size');
    this.innerLeg = this.form.elements.namedItem('innerLeg');
    this.position = this.form.elements.namedItem('position');
    this.result = this.querySelector('[data-result]');
    this.warning = this.querySelector('[data-warning]');

    this.fill(this.model, [...new Set(edropperFrames.map((entry) => entry[0]))]);
    this.model.addEventListener('change', () => {
      this.fill(this.frame, [...new Set(edropperFrames
        .filter((entry) => entry[0] === this.model.value)
        .map((entry) => entry[1]))]);
      this.fill(this.size, []);
      this.clear();
    });
    this.frame.addEventListener('change', () => {
      this.fill(this.size, [...new Set(edropperFrames
        .filter((entry) => entry[0] === this.model.value && entry[1] === this.frame.value)
        .map((entry) => entry[2]))]);
      this.clear();
    });
    this.size.addEventListener('change', () => this.clear());
    this.innerLeg.addEventListener('input', () => this.clear());
    this.position.addEventListener('input', () => this.clear());
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculate();
    });
  }

  fill(select, values) {
    select.replaceChildren(new Option(select.dataset.placeholder, ''));
    values.forEach((value) => select.add(new Option(
      this.dataset[value.replaceAll(' ', '').toLowerCase()] || value, value
    )));
    select.disabled = values.length === 0;
  }

  clear() {
    this.result.hidden = true;
    this.warning.hidden = true;
  }

  calculate() {
    this.clear();
    if (!this.form.reportValidity()) return;
    const innerLeg = Number(this.innerLeg.value);
    const position = Number(this.position.value);
    if (!Number.isFinite(innerLeg) || innerLeg <= 0 ||
        !Number.isFinite(position) || position < -30 || position > 30) return;

    const frame = edropperFrames.find((entry) =>
      entry[0] === this.model.value &&
      entry[1] === this.frame.value &&
      entry[2] === this.size.value
    );
    if (!frame) return;

    const result = calculateEdropper(frame, innerLeg, position);
    this.querySelector('[data-post]').textContent = result
      ? (result.post === 'Rigid 300 mm' ? this.dataset.rigid : result.post)
      : this.dataset.unavailable;
    this.querySelector('[data-scale]').textContent = result
      ? String(result.scale).replace('.', this.dataset.decimal)
      : this.dataset.unavailable;
    this.warning.hidden = innerLeg >= 60 && innerLeg <= 100;
    this.result.hidden = false;
  }
}

if (!customElements.get('edropper-size-calculator')) {
  customElements.define('edropper-size-calculator', EdropperSizeCalculator);
}
